import { Minus, Plus } from 'lucide-react';
import { Icon } from '../primitives';
import { useConsentStore } from '../../store/consentStore';

export default function CreateActionControls({
  batchCount,
  maxBatch = 4,
  totalCredits,
  totalCreditsWord,
  balanceValue,
  createLabel,
  balanceLabel,
  generatingLabel,
  loading = false,
  disabled = false,
  disabledVariant = 'neutral',
  showCounter = true,
  onCreate,
  onDecrease,
  onIncrease,
  singleLineLabel = false,
  className = '',
  counterTestId,
  buttonTestId,
}) {
  const showBalance = useConsentStore((state) => (
    state.consentRequired === false || state.versionChanged === true
  ));
  const isDisabled = disabled || loading;
  const disabledGold = isDisabled && disabledVariant === 'gold';

  return (
    <div className={`flex items-stretch gap-3 ${className}`}>
      {showCounter ? (
        <div
          className="flex h-[60px] items-center gap-2 rounded-2xl bg-white/[0.08] p-0.5"
          data-testid={counterTestId}
        >
          <button
            type="button"
            onClick={onDecrease}
            disabled={batchCount <= 1 || loading}
            className="flex h-full w-10 items-center justify-center rounded-2xl bg-white/[0.16] text-white disabled:opacity-30"
            aria-label="−"
          >
            <Minus className="h-4 w-4" />
          </button>
          <div className="flex items-center px-1 text-base font-semibold">
            <span className="text-white">{batchCount}</span>
            <span className="text-[#7B7B7C]">/{maxBatch}</span>
          </div>
          <button
            type="button"
            onClick={onIncrease}
            disabled={batchCount >= maxBatch || loading}
            className="flex h-full w-10 items-center justify-center rounded-2xl bg-white/[0.16] text-white disabled:opacity-30"
            aria-label="+"
          >
            <Plus className="h-4 w-4" />
          </button>
        </div>
      ) : null}

      <button
        type="button"
        onClick={onCreate}
        disabled={isDisabled}
        className={[
          'flex h-[60px] flex-1 flex-col items-center justify-center rounded-2xl',
          isDisabled
            ? disabledGold
              ? 'text-[#010103]/70'
              : 'bg-white/10 text-white/40'
            : 'text-[#010103]',
        ].join(' ')}
        style={
          disabledGold
            ? { background: 'linear-gradient(135deg, rgba(160,116,31,0.72) 0%, rgba(122,82,21,0.72) 100%)' }
            : isDisabled
              ? undefined
            : { background: 'linear-gradient(135deg, #FFC24C 0%, #FF9012 100%)' }
        }
        data-testid={buttonTestId}
      >
        {loading ? (
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-black/20 border-t-black" />
            <span className="text-sm font-bold">{generatingLabel}</span>
          </div>
        ) : (
          <>
            <span className="text-sm font-bold tracking-tight">
              {createLabel} ({totalCredits} {totalCreditsWord})
            </span>
            {!singleLineLabel && showBalance ? (
              <span
                className="mt-0.5 flex items-center gap-1 text-xs font-bold"
                style={{ opacity: 0.64 }}
              >
                <span>{balanceLabel}:</span>
                <span>{balanceValue}</span>
                <Icon name="coin" size={12} className="text-[#010103]" />
              </span>
            ) : null}
          </>
        )}
      </button>
    </div>
  );
}
